import { useState } from 'react'
import AsyncSelect from 'react-select/async';
import { DISEASE_GET_ALL_NEW } from '../../api/Routes';
import Get from '../../api/Get';


function SelectAjaxDiagnostico(props) {
    const [sugestion, setSugestion] = useState([])

    const filterData = (inputValue, temp) => {
        return temp.filter(i =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
        );
    };

    const loadOptions = (inputValue, callback) => {
        if (!inputValue) {
            callback([])
        } else {
            Get({ url: `${DISEASE_GET_ALL_NEW}/0/10/id/asc/true/${inputValue}`, access_token: props.access_token, noToken: props.noToken ? props.noToken : false })
                .then(res => {
                    const temp = []
                    if (res.data.state) {
                        res.data.data.response.content.forEach(element => {
                            const code = element?.code4digits || '';

                            const shouldInclude = props.idSpeciality === 140 || (!code.startsWith('CN') && !code.startsWith('FL'));

                            if (shouldInclude) {
                                temp.push({
                                    value: element.id,
                                    label: `${code} - ${element?.description}`
                                });
                            }
                        });
                    }
                    callback(filterData(inputValue, temp))
                    setSugestion(res.data.data)

                })
                .catch(err => {
                    // console.log(err)
                })
        }
    };

    const customStyles = {
        control: styles => ({ ...styles, borderColor: 'red' })
    }

    return (
        <AsyncSelect
            styles={!props.valid && customStyles}
            defaultValue={props.defaultValue}
            isMulti={props.isMulti}
            cacheOptions
            defaultOptions={
                props.defaultOptions.filter(opt => {
                    const code = opt.label.split(' ')[0];
                    return props.idSpeciality === 140 || (!code.startsWith('CN') && !code.startsWith('FL'));
                })
            }
            loadOptions={loadOptions}
            placeholder={props.placeholder ? props.placeholder : 'Escriba para buscar'}
            onChange={props.handleChange}
            value={props.value}
            isClearable={props.isClearable}
            className={props.className}
            loadingMessage={() => <span>Buscando opciones...</span>}
            noOptionsMessage={({ inputValue }) => {
                if (inputValue === "") {
                    return <span>Escriba para buscar</span>
                } else {
                    return <span>No hay opciones que mostrar</span>
                }

            }}
        />
    )

}

export default SelectAjaxDiagnostico